import { useTranslation } from 'react-i18next'

import { Attachment } from './Attachment'
import { SectionHeader } from './SectionHeader'

interface AttachmentsSectionProps {
  attachments?: File[] | string[]
}

export const AttachmentsSection = ({ attachments }: AttachmentsSectionProps) => {
  const { t } = useTranslation(['eventManagement'])

  if (!attachments?.length) {
    return null
  }

  return (
    <div className="attachments-section">
      <SectionHeader header={t('eventManagement:common.attachments')} />
      <div className="attachments-section__list">
        {attachments.slice(0, 2).map((file, i) => {
          const isString = typeof file === 'string'
          const fileType = isString ? file.split('.')[1] : file.type.split('/')[1]
          return <Attachment key={`${isString ? file : file.type}-${i}`} fileType={fileType} />
        })}
      </div>
    </div>
  )
}
